<mat-progress-bar *ngIf="isSearching" mode="indeterminate"></mat-progress-bar>
<div class="invoices background-white">
  <div class="filter-and-add">
    <div class="invoice-filter">
      <mat-form-field [hideRequiredMarker]="true" style="height: 48px; width: 280px" appearance="outline"
        [ngClass]="{ 'small-placeholder': isInputFocused }">
        <mat-label>Search by folder or invoice name </mat-label>
        <input matInput #input [(ngModel)]="searchTemplateInput" (focus)="isInputFocused = true"
          (blur)="isInputFocused = false" (keyup)="filterInvoices(input.value)" (input)="toggleIcon()" />
        <mat-placeholder style="color: brown">Enter your name here</mat-placeholder>
        <mat-icon style="cursor: pointer; margin-top: 5px" *ngIf="showClearIcon" matSuffix
          (click)="clearSearch()">close</mat-icon>
        <mat-icon matSuffix *ngIf="!showClearIcon && !isInputFocused">search</mat-icon>
      </mat-form-field>
    </div>
    <div class="add-invoice">
      <button class="secondary-button" (click)="createInvoice()">
        <mat-icon>post_add</mat-icon>
        <span>{{ "createInvoice" | translate }}</span>
      </button>

      <button class="secondary-button" (click)="openYourBooks()">
        <mat-icon>auto_stories</mat-icon>
        <span>{{ "yourBooks" | translate }}</span>
      </button>

      <button class="primary-button with-padding" (click)="createFolder()" style="width: 202px">
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 12H14V10H16V8H14V6H12V8H10V10H12V12ZM2 16C1.45 16
                   0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V2C0 1.45
                   0.196 0.979333 0.588 0.588C0.979333 0.196 1.45 0 2 0H8L10 2H18C18.55
                   2 19.021 2.196 19.413 2.588C19.8043 2.97933 20 3.45 20 4V14C20 14.55
                   19.8043 15.021 19.413 15.413C19.021 15.8043 18.55 16 18 16H2ZM2
                   2V14H18V4H9.175L7.175 2H2Z" fill="white" />
        </svg>
        &nbsp;
        <span>{{ "createFolder" | translate }}</span>
      </button>
    </div>
  </div>
  <ng-container *ngIf="!isLoading && items?.length && !isDownloadInProgress">
    <div class="scrollable-container" #scrollableContainer (scroll)="onScroll($event)"
      style="padding-bottom: 16px; overflow-x: auto; margin-top: 100p">
      <table class="si-table">
        <thead style="z-index: 1">
          <tr>
            <th>
              <div class="header-content">
                <button mat-icon-button (click)="toggleSort('name')">
                  <svg class="asc" [class.active]="sort.name == 'asc'" width="10" height="5" viewBox="0 0 10 5"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 -4.37114e-07L10 5L0 5L5 -4.37114e-07Z" fill="#CCCCCC" />
                  </svg>
                  <svg class="desc" [class.active]="sort.name == 'desc'" width="10" height="5" viewBox="0 0 10 5"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 5L0 0H10L5 5Z" fill="#CCCCCC" />
                  </svg>
                </button>
                <span class="roboto">Name</span>
              </div>
            </th>
            <th>
              <div class="header-content">
                <button mat-icon-button (click)="toggleSort('number')">
                  <svg class="asc" [class.active]="sort.number == 'asc'" width="10" height="5" viewBox="0 0 10 5"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 -4.37114e-07L10 5L0 5L5 -4.37114e-07Z" fill="#CCCCCC" />
                  </svg>
                  <svg class="desc" [class.active]="sort.number == 'desc'" width="10" height="5" viewBox="0 0 10 5"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 5L0 0H10L5 5Z" fill="#CCCCCC" />
                  </svg>
                </button>
                <span class="roboto">Invoices</span>
              </div>
            </th>
            <th>
              <div class="header-content">
                <button mat-icon-button (click)="toggleSort('status')">
                  <svg [class.active]="sort.status == 'asc'" class="asc" width="10" height="5" viewBox="0 0 10 5"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 -4.37114e-07L10 5L0 5L5 -4.37114e-07Z" fill="#CCCCCC" />
                  </svg>
                  <svg [class.active]="sort.status == 'desc'" class="desc" width="10" height="5" viewBox="0 0 10 5"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 5L0 0H10L5 5Z" fill="#CCCCCC" />
                  </svg>
                </button>
                <span class="roboto">Activity</span>
              </div>
            </th>
            <th>
              <div class="header-content">
                <button mat-icon-button (click)="toggleSort('latestScanType')">
                  <svg class="asc" [class.active]="sort.latestScanType == 'asc'" width="10" height="5"
                    viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 -4.37114e-07L10 5L0 5L5 -4.37114e-07Z" fill="#CCCCCC" />
                  </svg>
                  <svg class="desc" [class.active]="sort.latestScanType == 'desc'" width="10" height="5"
                    viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 5L0 0H10L5 5Z" fill="#CCCCCC" />
                  </svg>
                </button>
                <span class="roboto">Latest Scan Type</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="show-on-hover cursor-pointer" [class.drop-target]="dropTargetFolder?.id === item.id"
            (mouseover)="onMouseOver(i)" (mouseleave)="onMouseLeave(i)" *ngFor="
              let item of items
                | sort : sort[activeSort] : activeSort : 'string';
              let i = index
            " (click)="openItem(item, $event)" [draggable]="true" (dragstart)="onFolderDragStarted(item, $event)"
            (dragend)="onFolderDragEnded()"
            (dragover)="(isDraggingFolder && draggedFolder?.id !== item.id) ? onFolderDragOver($event, item) : null"
            (dragleave)="onFolderDragLeave()"
            (drop)="(isDraggingFolder && draggedFolder?.id !== item.id) ? onFolderDrop($event, item) : null">
            <td style="padding-left: 47px" class="sorted">
              <div class="item-name">
                <mat-icon *ngIf="item.type === 'folder' && item.isPasswordProtected"
                  style="font-size:16px;width:16px;height:16px;vertical-align:middle;margin-right:4px;color:#1e31cf"
                  matTooltip="Password protected">lock</mat-icon>
                {{ item.type === 'folder' ? item.name : item.title }}
              </div>
            </td>
            <td class="sorted" style="width: 100px">
              <p>
                {{ item.type === 'folder' ? (item.invoicesCount || '-') : 1 }}
              </p>
            </td>

            <td class="scan-task-status-sorted">
              <app-invoice-status-label [item]="item"></app-invoice-status-label>
            </td>
            <td class="sorted">
              <div class="latest-scan-type">{{item.type == "folder" ? item.latestScanType : "" }}</div>
            </td>
            <td>
              <div class="operations triggered" [ngStyle]="{
                  opacity: hoveredIndex === i || openDropdownIndex === i ? 1 : 0
                }" style="
                  display: flex;
                  align-items: center;
                  transition: opacity 0.2s ease;
                ">
                <!-- <button
                      *ngIf="!isProcessing(getStatus(item))"
                      mat-icon-button
                      [disabled]="isProcessing(getStatus(item))"
                      (click)="$event.stopPropagation(); deleteFolder($event, item)"
                      > -->
                <div class="icon-wrapper" (click)="$event.stopPropagation(); deleteFolder($event, item)"
                  (mouseover)="isHovered = true" (mouseleave)="isHovered = false"
                  *ngIf="!isProcessing(getStatus(item)) && item.type == 'folder'">
                  <svg (click)="
                      $event.stopPropagation(); deleteFolder($event, item)
                    " width="24" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                    [style.fill]="isHovered ? '#1E31CF' : '#27272C'">
                    <path d="M3 18C2.45 18 1.97933 17.8043 1.588
                      17.413C1.196
                      17.021 1 16.55 1
                      16V3H0V1H5V0H11V1H16V3H15V16C15
                      16.55
                      14.8043 17.021 14.413 17.413C14.021 17.8043
                      13.55
                      18
                      13
                      18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9
                      14H11V5H9V14Z" />
                  </svg>
                </div>
                <!-- </button> -->
                <!-- matTooltip="You have new changes in the folder, since the last Run" -->
                <!-- *ngIf="item.status == folderStatuses.FAILED" -->
                <button *ngIf="false && item.type == 'folder'" class="hide-text" matBadge="&#8288;"
                  matBadgePosition="before" matBadgeColor="warn" mat-icon-button>
                  <svg width="16" height="16" viewBox="0 0 16
                      16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 16C1.45 16 0.979333 15.8043
                         0.588
                         15.413C0.196 15.021 0 14.55 0
                         14V11H2V14H14V11H16V14C16 14.55 15.8043
                         15.021
                         15.413
                         15.413C15.021 15.8043 14.55 16 14 16H2ZM8
                         12L3
                         7L4.4
                         5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12Z" fill="#CCCCCC" />
                  </svg>
                </button>
                <button mat-icon-button *ngIf="
                    item.type == 'folder' && 
                    item.status == folderStatuses.SUCCESS &&
                    item.invoicesCount !== 0
                  " (click)="$event.stopPropagation(); openTemplateDialog(item)" matTooltipClass="custom-tooltip">
                  <svg *ngIf="
                      !item.areThereMissingFields || item.areThereMissingFields
                    " class="success-included-download-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_1988_34489" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                      width="24" height="24">
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_1988_34489)">
                      <path
                        d="M6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.196 19.021 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8043 19.021 19.413 19.413C19.021 19.8043 18.55 20 18 20H6ZM12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16Z"
                        fill="#1C1B1F" />
                    </g>
                  </svg>
                </button>
                <mat-menu #menu="matMenu" [overlapTrigger]="false">
                  <!-- <button mat-menu-item (click)="runNano(item)">Nano</button> -->
                  <button mat-menu-item 
                    (click)="runFolder(item.id, item, TF.FALSE)"
                    [disabled]="hasFilesRequiringGoodsAndMaterialProcessing(item)"
                    [matTooltip]="hasFilesRequiringGoodsAndMaterialProcessing(item) ? 'TXT/XLSX files require Goods and Material processing' : ''"
                    [class.disabled-menu-item]="hasFilesRequiringGoodsAndMaterialProcessing(item)">
                    Regular
                  </button>
                  <button mat-menu-item (click)="runFolder(item.id, item, TF.TRUE)">
                    Goods and Material
                  </button>
                  <mat-divider></mat-divider>
                  <button mat-menu-item (click)="setFolderPassword($event, item)">
                    <mat-icon>{{ item.isPasswordProtected ? 'lock' : 'lock_open' }}</mat-icon>
                    {{ item.isPasswordProtected ? 'Manage password' : 'Set password' }}
                  </button>
                </mat-menu>
                <button *ngIf="!isProcessing(getStatus(item)) && item.type == 'folder'" mat-button
                  class="right-side-folder-button" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"
                  (menuOpened)="toggleDropdown(i, true)" (menuClosed)="toggleDropdown(i, false)" [disabled]="
                    item.invoices?.items?.length === 0 ||
                    isProcessing(getStatus(item)) ||
                    checkLengthOfInvoicesObj(item)
                  " [class.disabled-run-button]="
                    item.invoices?.items?.length === 0 ||
                    isProcessing(getStatus(item)) ||
                    checkLengthOfInvoicesObj(item)
                  ">
                  {{ "run" | translate }}
                </button>
                <button *ngIf="isProcessing(getStatus(item))" mat-button class="right-side-folder-button red-button"
                  (click)="
                    $event.stopPropagation(); stopScanning(item.id, item)
                  ">
                  Stop scanning
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
  <ng-container *ngIf="!isLoading && !isDownloadInProgress && !items?.length && !isSearching">
    <div class="no-data-wrapper">
      <img [style.width]="!items?.length && !isSearchFilterOn ? '139px' : '200px'" height="225px" [src]="
          !items?.length && !isSearchFilterOn
            ? '/assets/icons/printer.svg'
            : '/assets/icons/empty-search.svg'
        " />
      <p class="no-data-title">No results</p>
      <p *ngIf="!items?.length && !isSearchFilterOn">
        Press the button at the top right corner <br />
        to create your first folder.
      </p>
      <p *ngIf="!items?.length && isSearchFilterOn">
        We are sorry, we couldn’t find any matching <br />
        results. Please try different search.
      </p>
    </div>
  </ng-container>
  <ng-container *ngIf="isLoading || isDownloadInProgress">
    <table style="margin-top: 10px" class="si-table">
      <tbody>
        <tr *ngFor="let number of [1, 2, 3, 4, 5]">
          <td>
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                height: '15px',
                width: '150px',
                'border-radius': '3px'
              }">
            </ngx-skeleton-loader>
          </td>
          <ngx-skeleton-loader count="1" appearance="line"
            [theme]="{ height: '15px', width: '70px', 'border-radius': '3px' }">
          </ngx-skeleton-loader>
          <td></td>
          <ngx-skeleton-loader count="1" appearance="line"
            [theme]="{ height: '15px', width: '300px', 'border-radius': '3px' }">
          </ngx-skeleton-loader>
          <td></td>
          <ngx-skeleton-loader count="1" appearance="circle" class="centered">
          </ngx-skeleton-loader>
          <td></td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
<ng-template #customTooltip>
  <div class="custom-tooltip-content">
    You have new changes in the folder, since the last Run 1
  </div>
</ng-template>